import React, { createContext, useState } from 'react';
import PropTypes from 'prop-types';

const defaultState = { lang: 'en-ca', path: 'main-en' };

const IntlContext = createContext(defaultState);

const IntlProvider = ({ children }) => {
  const [intl, setIntl] = useState(defaultState);

  return (
    <IntlContext.Provider
      value={{
        intl,
        setIntl,
      }}
    >
      {children}
    </IntlContext.Provider>
  );
};

IntlProvider.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
};

export { IntlContext, IntlProvider };
